var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('GoogleLogin',{attrs:{"login":_vm.isLogin},on:{"click":_vm.googleLogin}})],1),_vm._v(" "),_c('b-col',[_c('FacebookLogin',{attrs:{"login":_vm.isLogin},on:{"click":_vm.facebookLogin}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }